<template>
	<label class="BaseCheckBox" :class="{'BaseCheckBox--inline': inline }">
		<input
			type="checkbox"
			class="BaseCheckBox-input"
			:checked="modelValue"
			@change="$emit('update:modelValue', $event.target.checked)"
		>
		<span class="BaseCheckBox-label" v-if="label">{{ label }}</span>
	</label>
</template>

<script>
export default {
	name: 'BaseCheckBox',
	props: {
		modelValue: {
			type: Boolean,
			default: false,
		},
		label: String,
        inline: Boolean
	}
}
</script>

<style lang="scss" scoped>
.BaseCheckBox {
	display: flex;
	margin-top: 1em;

	&:first-child {
		margin-top: 0;
	}

	&-input {
		-moz-appearance: none;
		-webkit-appearance: none;
		appearance: none;
		width: 1.2em;
		height: 1.2em;
		border: .2em solid var(--colorBrand);
		box-shadow: inset 0 0 0 .15em #fff;
		outline: none;
		margin: .214em 0 0;
		border-radius: 0;

		&:checked {
			background: var(--colorBrand);
		}
	}

	&-label {
		flex: 1;
		margin-left: .8em;
	}

    &--inline {
        align-items: center;
    }

    &--inline &-label {
        font-weight: 700;
    }
}
</style>
